const ROOT_URL = "https://docshub.run.ai";
const LATEST_URL = "https://docs.run.ai/latest";
// when you change this link make sure you update the login-success.html as well
const SUPPORT_URL = "https://www.nvidia.com/en-eu/support/enterprise/#contact-us";

export const DOCS = {
  ROOT: ROOT_URL,

  INSTALLATION: {
    PREREQUISITES: `${ROOT_URL}/guides/self-hosted-installation/installation/system-requirements`,
    NETWORK_REQUIREMENTS: `${ROOT_URL}/guides/self-hosted-installation/installation/network-requirements`,
    HELM_INSTALL: `${ROOT_URL}/guides/self-hosted-installation/installation/helm-install`,
    CUSTOM_INSTALL: `${ROOT_URL}/guides/self-hosted-installation/installation/custom-install`,
    UNINSTALL: `${ROOT_URL}/guides/self-hosted-installation/installation/uninstall`,
    FQDN_REQUIREMENTS: `${ROOT_URL}/guides/self-hosted-installation/installation/system-requirements#fully-qualified-domain-name-fqdn`,
    DISTRIBUTED_TRAINING: `${ROOT_URL}/guides/self-hosted-installation/installation/system-requirements#distributed-training`,
  },

  AUTHENTICATION: {
    OVERVIEW: `${ROOT_URL}/guides/infrastructure-setup/authentication/overview`,
    SAML: `${ROOT_URL}/guides/infrastructure-setup/authentication/sso/saml`,
    OIDC: `${ROOT_URL}/guides/infrastructure-setup/authentication/sso/openidconnect`,
    OPENSHIFT: `${ROOT_URL}/guides/infrastructure-setup/authentication/sso/openshift`,
    RESEARCHER: {
      OVERVIEW: `${LATEST_URL}/admin/runai-setup/authentication/researcher-authentication`,
      CLI_ACCESS: `${LATEST_URL}/admin/runai-setup/authentication/researcher-authentication/#command-line-interface-access`,
      K8S_CONFIG: `${LATEST_URL}/admin/runai-setup/authentication/researcher-authentication/#kubernetes-configuration`,
    },
  },

  CLI: {
    INSTALL: `${ROOT_URL}/guides/reference/cli/install-cli`,
    SUBMIT: `${LATEST_URL}/Researcher/cli-reference/runai-submit/`,
  },

  PLATFORM_MANAGEMENT: {
    PROJECTS: `${ROOT_URL}/guides/platform-management/aiinitiatives/organization/projects`,
    DEPARTMENTS: `${ROOT_URL}/guides/platform-management/aiinitiatives/organization/departments`,
    POLICIES: `${ROOT_URL}/guides/platform-management/policies/policies-and-rules`,
    SCHEDULING_RULES: `${ROOT_URL}/guides/platform-management/policies/scheduling-rules`,
    SCHEDULING_CONCEPTS: `${ROOT_URL}/guides/platform-management/runai-scheduler/scheduling/concepts-and-principles`,
    ORGANIZATION: {
      PROJECTS: `${ROOT_URL}/guides/platform-management/aiinitiatives/organization/projects`,
      DEPARTMENTS: `${ROOT_URL}/guides/platform-management/aiinitiatives/organization/departments`,
    },
    NODE_GROUPS: `${LATEST_URL}/admin/researcher-setup/limit-to-node-group`,
  },

  WORKLOADS: {
    DATA_VOLUMES: `${ROOT_URL}/guides/workloads-in-nvidia-run-ai/assets/data-volumes`,
  },

  TROUBLESHOOTING: {
    CLUSTERS: `${ROOT_URL}/guides/infrastructure-setup/procedures/clusters`,
  },

  CONFIGURATION: {
    NON_ROOT_CONTAINERS: `${LATEST_URL}/admin/runai-setup/config/non-root-containers`,
  },

  WHATS_NEW: {
    getVersionPage: (version: string): string => {
      return `${ROOT_URL}/whats-new/whats-new-${version.replace("v", "").replace(".", "-")}`;
    },
  },

  EXTERNAL: {
    VLLM: {
      SUPPORTED_MODELS: "https://docs.vllm.ai/en/latest/models/supported_models.html",
    },
    HUGGING_FACE: {
      TGI_SUPPORTED_MODELS: "https://huggingface.co/docs/text-generation-inference/en/supported_models",
    },
  },

  // when you change these links make sure you update the login-success.html as well
  SUPPORT: {
    URL: `${SUPPORT_URL}`,
  },

  KUBERNETES: {
    TASKS: {
      EXTENDED_RESOURCES: "https://kubernetes.io/docs/tasks/configure-pod-container/extended-resource/",
    },
    REFERENCE: {
      API: {
        QUANTITY: "https://kubernetes.io/docs/reference/kubernetes-api/common-definitions/quantity/",
      },
    },
  },
} as const;

export type DocsType = typeof DOCS;

export default DOCS;
